
import React from 'react';
import { cn } from '@/lib/utils';
import { ScrollArea as ScrollAreaBase, ScrollBar } from './scroll-area';

interface ScrollAreaWithChildrenProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  dir?: 'ltr' | 'rtl';
}

export const ScrollArea = React.forwardRef<
  HTMLDivElement,
  ScrollAreaWithChildrenProps
>(({ className, children, dir, ...props }, ref) => (
  <ScrollAreaBase ref={ref} className={cn(className)} dir={dir} {...props}>
    {children}
    <ScrollBar orientation="vertical" />
    <ScrollBar orientation="horizontal" />
  </ScrollAreaBase>
));

ScrollArea.displayName = 'ScrollArea';

// Export ScrollAreaWithChildren as a named export
export const ScrollAreaWithChildren = ScrollArea;

// Export the components explicitly
export { ScrollBar };
